import { COLOR_SYSTEM, Badge, Text, typography, Icon } from "components/atoms";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { LogLevel, log } from "utils/LogUtil";

const SideNavigationLayout = styled.div`
  width: 310px;
  min-width: 310px;
  min-height: calc(100vh - 80px);
  padding: 0 40px;
  align-items: right;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[0]};
  position: relative;
`;

const SideNavigationList = styled.div`
  position: sticky;
  top: 120px;
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 8px;
  width: 100%;
`;

export interface SideNavigationItemWrapperProps {
  selected?: boolean;
}
const SideNavigationItemWrapper = styled.li<SideNavigationItemWrapperProps>`
  width: 200px;
  display: flex;
  gap: 12px;
  border-radius: 10px;
  padding: 16px;
  align-items: center;
  white-space: nowrap;
  background: ${({ selected }) =>
    selected ? COLOR_SYSTEM.get("Blue")?.[10] : COLOR_SYSTEM.get("Gray")?.[0]};

  ${({ disabled }) => {
    if (disabled) return `opacity: 0.3;`;
    else return `cursor: pointer;`;
  }}
`;

interface SideNavigationProps {}

const SideNavigation: React.FC<SideNavigationProps> = ({}) => {
  const { pathname } = useLocation();
  log(LogLevel.VERBOSE, "SideNavigation: render hello");

  return (
    <SideNavigationLayout>
      <SideNavigationList>
        <SideNavigationItem icon="Document" name="보고서 관리" path="/mypage/ai-reviews" />
        <SideNavigationItem icon="Won" name="멤버십 및 포인트" path="/mypage/billing" />
        <SideNavigationItem icon="Setting 01 Filled" name="계정 관리" path="/mypage/accounts" />
        <SideNavigationItem icon="Trash Filled" name="휴지통" path="/mypage/trash" />
      </SideNavigationList>
    </SideNavigationLayout>
  );
};

export default SideNavigation;

export interface SideNavigationItemProps {
  path: string;
  name: string;
  icon: string;
  count?: number;
  disabled?: boolean;
}

const SideNavigationItem: React.FC<SideNavigationItemProps> = ({
  path,
  name,
  icon,
  count = 0,
  disabled = false,
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const onClick = () => {
    if (!disabled) navigate(path);
  };
  const color = pathname.includes(path)
    ? COLOR_SYSTEM.get("Blue")[400]
    : COLOR_SYSTEM.get("Gray")[400];

  return (
    <SideNavigationItemWrapper
      onClick={onClick}
      selected={pathname.includes(path)}
      disabled={disabled}
    >
      <Icon name={icon} size={16} color={color} />
      <Text textType={pathname.includes(path) ? "Body1Bold" : "Body1Medium"} color={color}>
        {name}
      </Text>
      {count > 0 && <Badge color={"Red"} content={count.toString()} />}
    </SideNavigationItemWrapper>
  );
};
